export default __webpack_public_path__ + "static/media/hht2_Intonation_08.9ee7cc63.png";